<template>
<v-card flat >
  <!-- <v-progress-linear v-if='request.loading' indeterminate height='2' class='ma-0' /> -->
  <div v-if='spaces && spaces.length > 0' >
    <v-alert
      dismissible
      type='warning' :value='true' class='py-0 px-2 ma-0'  >
      These appointments span multiple spaces.
      Please pick to which space you would like to assign this invoice to
    </v-alert>
    <div class='px-2' >
      <v-subheader class='py-0 px-2 overline ma-0' >Choose a space</v-subheader>
      <v-chip outline small class='mt-0'
          v-for='(space, index) in spaces' :key='space.id'
          @click='selectedSpaceSettings = index' >
          <v-icon v-if='index === selectedSpaceSettings' >check</v-icon>
          {{ space.space_name || space.practice_name }}
      </v-chip>
    </div>
  </div>

  <v-card tile>
    <v-system-bar class="overline" >Business settings</v-system-bar>
    <v-list dense one-line >
      <v-list-tile >
        <v-list-tile-avatar v-if="resizedLogoPicture" tile small >
          <v-img :src="resizedLogoPicture" />
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>
            <span v-if="settings && settings.practice_name" v-text="settings.practice_name" />
            <span v-else >Business details</span>
          </v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action >
          <v-btn small icon label
            @click.stop='configureSettings' class='pa-0 ma-0' >
            <v-icon small class='mr-1' >edit</v-icon>
          </v-btn>
        </v-list-tile-action>
        <v-list-tile-action >
          <v-btn small icon label
            v-if="localExpanded===false"
            @click.stop='localExpanded=true' class='pa-0 ma-0' >
            <v-icon small class='mr-1' >expand_more</v-icon>
          </v-btn>
          <v-btn small icon label v-else
            @click.stop='localExpanded=false' class='pa-0 ma-0' >
            <v-icon small class='mr-1' >expand_less</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider/>
    <template v-if="localExpanded" >
      <v-card-text @click="configureSettings" >
        <!-- {{ settings.practice_name || "No business name provided" }}. -->
        <strong class="overline">Practice number:</strong> {{ settings.practice_number }}
        <v-divider/>
        <strong class="overline" >Billing address</strong>:
        <pre v-if='settings.billing_address' v-text="settings.billing_address" class="caption" />
        <div v-else >Add a billing address</div>

        <strong class="overline">Banking details</strong>:
        <pre v-if="settings.banking_details" v-text="settings.banking_details" class="caption" />
        <div v-else >Add banking details</div>
      </v-card-text>
      <v-footer small block tile
        v-if='settings && requiredProgress < 100'
        class='mt-0 pl-2 py-0 caption' >
        <v-progress-circular
          @click.stop='configureSettings'
          :value='progressPercent' :color='progressColor'
          :rotate="-90" width='2' :size='24' class='mr-2' >
          <v-btn small icon >
            <v-icon small :color='progressColor' >{{progressIcon}}</v-icon>
          </v-btn>
        </v-progress-circular>
        Configuration suggestions
        <v-spacer/>
        <v-btn @click.stop='configureSettings' icon small ><v-icon small >edit</v-icon></v-btn>
        <!-- <v-divider vertical />
        <v-btn v-if='!showSuggestions' @click='showSuggestions=!showSuggestions' icon ><v-icon>expand_more</v-icon></v-btn>
        <v-btn v-else @click='showSuggestions=!showSuggestions' icon ><v-icon>expand_less</v-icon></v-btn> -->
      </v-footer>
    </template>
  </v-card>

  <!-- <v-list three-line class='pa-0 mt-4' >
    <v-list-group :value="expanded" >
      <v-list dense one-line slot='activator' >
        <v-list-tile >
          <v-list-tile-action >
            <v-btn small icon label
              @click.stop='configureSettings()' class='py-0' >
              <v-icon small class='mr-1' >edit</v-icon>
            </v-btn>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              <span v-if="settings && settings.practice_name" v-text="settings.practice_name" />
              <span v-else >Business details</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <!-- <v-card-title class='overline py-1 caption' slot='activator' >
        <span v-if="settings && settings.practice_name" v-text="settings.practice_name" />
        <span v-else >Business details</span>
        <v-spacer/>
        <v-btn small icon
          @click='get'
          :loading='request.loading'
          class='my-0 py-0' ><v-icon small>replay</v-icon></v-btn>
      </v-card-title>
      <v-divider/>
      <v-list-tile
        v-if='settings'
        @click='configureSettings' >
        <v-list-tile-content >
          <v-list-tile-title v-if="settings" >
            {{ settings.practice_name || "No business name provided" }}.
            <v-chip v-if='settings.practice_number' label class="v-chip--x-small" >{{ settings.practice_number }}</v-chip>
          </v-list-tile-title>

          <v-list-tile-sub-title v-if='settings.billing_address' v-text="settings.billing_address" />
          <v-list-tile-sub-title v-else >Add a billing address</v-list-tile-sub-title>

          <v-list-tile-sub-title v-if="settings.banking_details" v-text="settings.banking_details" />
          <v-list-tile-sub-title v-else >Add banking details</v-list-tile-sub-title>
        </v-list-tile-content>

        <v-list-tile-avatar tile >
          <v-img v-if='settings.logo_picture' :src='settings.logo_picture' />
          <template v-else >
            <v-icon>upload</v-icon>
            <v-list-tile-action-text >Upload logo</v-list-tile-action-text>
          </template>
        </v-list-tile-avatar>
      </v-list-tile>


      <v-divider/>
      <v-footer small block tile
        v-if='settings && requiredProgress < 100'
        class='mt-0 pl-2 py-0 caption' >
        <v-progress-circular
          @click.stop='configureSettings'
          :value='progressPercent' :color='progressColor'
          :rotate="-90" width='2' :size='24' class='mr-2' >
          <v-btn small icon >
            <v-icon small :color='progressColor' >{{progressIcon}}</v-icon>
          </v-btn>
        </v-progress-circular>
        Configuration suggestions
        <v-spacer/>
        <v-btn @click.stop='configureSettings' icon small ><v-icon small >edit</v-icon></v-btn>
        <v-divider vertical />
        <v-btn v-if='!showSuggestions' @click='showSuggestions=!showSuggestions' icon ><v-icon>expand_more</v-icon></v-btn>
        <v-btn v-else @click='showSuggestions=!showSuggestions' icon ><v-icon>expand_less</v-icon></v-btn>
      </v-footer>

      <v-list dense one-line
        v-show='showSuggestions'
        transition="scroll-y-transition" >

        <v-list-tile v-for='item in todoProgress' :key='item.title' >
          <v-list-tile-avatar >
            <v-icon small color='green' v-if='item.complete' >done</v-icon>
            <v-icon small color='amber' class='mt-3' v-else >close</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title v-text='item.title' />
            <v-list-tile-sub-title v-if='item.required' class='red--text' >
              * required
            </v-list-tile-sub-title>
            <v-list-tile-sub-title v-else class='warning--text' >
              * recommended
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-btn block small flat tile @click='configureSettings' >Edit</v-btn>
        <v-divider />
      </v-list>
    </v-list-group>
  </v-list>
  -->
</v-card>
</template>
<script>
export default {
  name: 'InvoiceBillingDetails',
  props: {
    request: { type: Object, required: true },
    expanded: { type: Boolean, default: true }
  },
  data () {
    return {
      showSuggestions: false,
      selectedSpaceSettings: 0,
      localExpanded: false
    }
  },
  mounted () {
    if (this.expanded === true) { this.localExpanded = true }
  },
  methods: {
    configureSettings () {
      let spaceId = this.spaceIds[0]
      let settings = this.settings
      let options = {spaceId, settings}
      this.launchInvoiceSettingsDialog(options)
    },
    get () {
      console.log('getting')
      this.$request('get', this.request)
    }
  },
  watch: {
    settings () {
      this.$emit('update:settings', this.settings)
    },
    invoiceSettingsChanged () {
      this.get()
    }
  },
  computed: {
    invoiceSettingsChanged () {
      // return 'asdas'
      return this.getObjectPath(this.$store.state.application, 'globalEventInformation.InvoiceSettings.touch')
      // return this.getObjectPath(this.$store.state.application, 'globalEventInformation.InvoiceSettings')
    },
    resizedLogoPicture () {
      if (this.settings && this.settings.logo_picture) {
        return this.imageKitUrl(this.settings.logo_picture, 'n-avatar_md')
      }
      return null
    },
    settings () {
      let space = this.getObjectPath(this.request, 'result.invoice.settings.space', null)
      if (space) { return space }
      let spaces = this.getObjectPath(this.request, 'result.invoice.settings.spaces', [])
      if (spaces && spaces.length > this.selectedSpaceSettings) {
        return spaces[this.selectedSpaceSettings]
      }
      return null
    },
    spaces () {
      return this.getObjectPath(this.request, 'result.invoice.settings.spaces', [])
    },
    appointments () {
      return this.getObjectPath(this.request, 'result.results', [])
    },
    spaceIds () {
      return this.appointments.map((appt) => {
        return appt.service_id
      })
    },
    progressColor () {
      if (this.requiredProgress < 100) { return 'error lighten-2' }
      if (this.recommendedProgress === 100) { return 'success' }
      return 'warning'
    },
    progressIcon () {
      if (this.requiredProgress < 100) { return 'error' }
      if (this.recommendedProgress === 100) { return 'check' }
      return 'warning'
    },
    progressPercent () {
      if (this.requiredProgress < 100) { return this.requiredProgress }
      if (this.recommendedProgress < 100) { return this.recommendedProgress }
      return 100
    },
    requiredProgress () {
      let requiredSteps = this.todoProgress.filter((item) => { return item.required })
      let completedSteps = requiredSteps.filter((item) => { return item.complete })
      if (requiredSteps.length === 0) { return 100 }
      return completedSteps.length / requiredSteps.length * 100
    },
    recommendedProgress () {
      let steps = this.todoProgress.filter((item) => { return item.required === false })
      let completed = steps.filter((item) => { return item.complete })
      if (steps.length === 0) { return 100 }
      return completed.length / steps.length * 100
    },
    todoProgress () {
      if (!this.settings) { return [] }
      let items = [
        {
          title: 'Billing address',
          complete: (this.settings.billing_address !== null),
          required: true
        },
        {
          title: 'Banking details',
          complete: (this.settings.banking_details !== null),
          required: true
        },
        {
          title: 'Logo',
          complete: (this.settings.logo_picture !== null),
          required: false
        },
        {
          title: 'Invoice notes',
          complete: (this.settings.invoice_notes !== null),
          required: false
        },
        {
          title: 'Receipt notes',
          complete: (this.settings.receipt_notes !== null),
          required: false
        }
      ]
      if (this.settings.integrate_medical_aid === true) {
        items = [
          {
            title: 'Practice name',
            text: 'The name of your business as you would like it to show on invoices',
            complete: (this.settings.practice_name !== null),
            required: true
          },
          {
            title: 'Practice number',
            text: 'The registration number for your practice. Required for medical practices',
            complete: (this.settings.practice_number !== null),
            required: true
          }
        ].concat(items)
      }
      return items
    }
  }
}
</script>



// WEBPACK FOOTER //
// InvoiceBillingDetails.vue?88284d52